module.exports = __webpack_public_path__ + "img/chinesecompany21.12a894fa.png";